const availableGenders = [
    {
        label: 'Feminino',
        code: 'F'
    },
    {
        label: 'Masculino',
        code: 'M'
    },
    {
        label: 'Transgênero',
        code: 'T'
    }
]

export default availableGenders